<div class="container cv-switch-component">
	<span class="switch action-toggle {{'btn-'+class}}"
		[attr.tabindex]="indexTab" 
		(keydown.Enter)="onToggle()" 
		(click)="onToggle()"
		[ngClass]="{
			'checked': checked, 
			'sm': size === 'sm',
			'disabled': disabled
		}">
		<small></small>
	</span>
</div>
